import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../actions'
import { formatName } from '../../../helpers'
import { Link } from 'react-router-dom'

class ComposeNotif extends Component {
  constructor (props) {
    super(props)

    this.state = {
      subject: '',
      message: ''
    }

    this.submitForm = this.submitForm.bind(this)
    this.dismissPopup = this.dismissPopup.bind(this)
  }

  dismissPopup () {
    this.props.dispatch(actions.switchSendNotif({}))
  }

  submitForm () {
    if (!this.props.subscribers ||
      this.props.subscribers.length === 0 ||
      this.state.subject === '' ||
      this.state.message === ''
    ) {
      this.props.dispatch(actions.displayAlert('Field(s) is/are missing.'))
      return
    }

    const action = 'team_invitation'
    const data = {
      title: this.state.subject,
      message: this.state.message,
      author: this.props.user.participantId,
      subscribers: [...this.props.subscribers]
    }

    this.props.dispatch(actions.socketSendMessage({ action, data: [data] }))
    this.props.dispatch(actions.switchSendNotif({}))
  }

  render () {
    return (
      <div className='dashboard-popup-notif'>
        <div className='hey-popup-header'>
          <h4 className='header-text'>SEND MESSAGE</h4>
          <button
            onClick={this.dismissPopup}
            className='black-cross'>
            <img alt='' src='/imgs/close.png' />
          </button>
        </div>
        <div className='line'>
          <div className='left'>
            <div> Subject:</div>
          </div>
          <div className='center'>
            <input
              className='subject-input'
              value={this.state.subject || ''}
              onChange={ev => this.setState({ subject: ev.target.value })}
              type='text'
              placeholder='subject/title' />
          </div>
          <div className='right'>
            {/* <img alt='' src='/imgs/single-reply.png' width='20px' height='15px' className='arrow' />
            <img alt='' src='/imgs/double-arrow.png' width='25px' height='15px' className='arrow' /> */}
            {/* <img
              className='cursor-pointer'
              onClick={() => this.deleteNotif(notif._id)}
              alt='' src='/imgs/bin.png' width='20px' height='15px/' /> */}
          </div>
        </div>
        <div className='silver-line' />
        <div className='line'>
          <div className='left'>
            <div> From:</div>
            <div> To:</div>
          </div>
          <div className='center'>
            <div>{formatName(this.props.user.name)}</div>
            <div>
              {this.props.subscribers && this.props.subscribers.map(s => {
                const subscriber = this.props.players.find(p => p.id === s)
                if (subscriber) {
                  return (
                    <Link
                      key={subscriber.id}
                      target='_blank'
                      to={`/player/${subscriber.id}`}>
                      <span className='red' >{subscriber.handle}, </span>
                    </Link>
                  )
                } else { return (<span key={s} />) }
              })}
            </div>
          </div>
          <div className='right'>
            <div className='cell-date' />
          </div>
        </div>
        <div className='silver-line' />
        <div className='pop-message-container '>
          <div className='dashboard-players2'>
            <div className='y-scroll-wrap2'>
              <div className='y-scroll2'>
                <div className='dashboard-players-list2'>
                  <div className='dashboard-players-row2'>
                    <textarea
                      className='message-input'
                      value={this.state.message || ''}
                      onChange={ev => this.setState({ message: ev.target.value })}
                      type='text'
                      placeholder='message' />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='popup-button-cont'>
          <button
            onClick={this.submitForm}
            className='button-bt '>send<img alt='' src='/imgs/white-send.png' width='15px' height='15px' className='white-send' /></button>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    subscribers: state.popup.payload,
    players: state.participants
  }
}

export default connect(mapStateToProps)(ComposeNotif)



// WEBPACK FOOTER //
// ./src/components/common/popups/ComposeNotif.js